export default __webpack_public_path__ + "12521d89e0febe9894e8e01ef7d18d16.svg";